/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * What was requested.
 */
export const Kind = {
  WorkosRoleSync: "workos_role_sync",
} as const;
/**
 * What was requested.
 */
export type Kind = OpenEnum<typeof Kind>;

/**
 * Requested work runs after the response and is never reported as done.
 */
export const RequestStatus = {
  Requested: "requested",
} as const;
/**
 * Requested work runs after the response and is never reported as done.
 */
export type RequestStatus = OpenEnum<typeof RequestStatus>;

export type DirectoryRoleSetupSideEffect = {
  /**
   * What was requested.
   */
  kind: Kind;
  /**
   * Requested work runs after the response and is never reported as done.
   */
  requestStatus: RequestStatus;
  /**
   * The role the request is for.
   */
  roleId: string;
};

/** @internal */
export const Kind$inboundSchema: z.ZodMiniType<Kind, unknown> = openEnums
  .inboundSchema(Kind);

/** @internal */
export const RequestStatus$inboundSchema: z.ZodMiniType<
  RequestStatus,
  unknown
> = openEnums.inboundSchema(RequestStatus);

/** @internal */
export const DirectoryRoleSetupSideEffect$inboundSchema: z.ZodMiniType<
  DirectoryRoleSetupSideEffect,
  unknown
> = z.pipe(
  z.object({
    kind: Kind$inboundSchema,
    request_status: RequestStatus$inboundSchema,
    role_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "request_status": "requestStatus",
      "role_id": "roleId",
    });
  }),
);

export function directoryRoleSetupSideEffectFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryRoleSetupSideEffect, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryRoleSetupSideEffect$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryRoleSetupSideEffect' from JSON`,
  );
}
